var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cont_r_b11"},[_c('blockquote',{staticStyle:{"margin":"0 0 0 40px","border":"none","padding":"0px"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text.profile6)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38227e24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zh/profile/gsjj.vue
// module id = null
// module chunks = 